import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const store = new Vuex.Store({

    state: {
        supplierInfo:{}
    },
    mutations: {
        setSupplierInfo(state,value){
            state.supplierInfo=value
        },
    }
})

export default store;



// WEBPACK FOOTER //
// ./src/vuex.js